module.exports = __webpack_public_path__ + "static/media/icon_edit.771d7e1f.svg";